module.exports = __webpack_public_path__ + "static/media/dokibo-map-icon.0745acc0.png";